/**
 * brushSceneManager — Visual bush meshes from plan.brushes (P3-10).
 * No gameplay formulas; presentation only.
 *
 * Contrato: syncBrushMeshes(scene, brushes, prevGroups, MeshFactory) → Group[]
 */
export function syncBrushMeshes(scene, brushes = [], prevGroups = [], MeshFactory) {
  for (const g of prevGroups) {
    if (g && scene) scene.remove(g);
  }
  if (!scene || !MeshFactory) return [];
  return brushes.map((b) => {
    const mesh = MeshFactory.createBushMesh(b.x, 0.75, b.z, b.radius || 2.2);
    mesh.name = b.id || `brush-${b.x}-${b.z}`;
    scene.add(mesh);
    return mesh;
  });
}
